import { Banner, Button, HorizontalStack, Text, VerticalStack } from "@shopify/polaris";
import { GettingStartedStoreAccess } from "../../../libs/store";
import { useOnPublishCustomerPortalToTheme } from "../../../libs/hooks/useOnPublishCustomerPortalToTheme";
import { UnsupportedThemeBanner } from "../UnsupportedThemeBanner";

export const LegacyCustomerAccountsSetup = () => {
  const chosenThemeId = GettingStartedStoreAccess.useChosenThemeId();
  const themes = GettingStartedStoreAccess.useThemes();
  const { isThemeValid } = GettingStartedStoreAccess.useThemeValidation();
  const isLoading = GettingStartedStoreAccess.useLoading("customerPortal");
  const setup = GettingStartedStoreAccess.useSetup();

  const onPublishToTheme = useOnPublishCustomerPortalToTheme();

  const isAlreadyInstalledToChosenTheme =
    setup?.onSiteSetup.smartrrSnippets?.completed && setup?.snippetsThemeId === chosenThemeId;

  if (!chosenThemeId) {
    return (
      <Banner status="info">
        <Text as="span" variant="bodyMd">
          Choose a theme in the &quot;Add Subscription App Block&quot; step above before installing the portal.
        </Text>
      </Banner>
    );
  }

  const chosenThemeIdNumber = Number(chosenThemeId);
  const chosenTheme = themes.find(theme => theme.id === chosenThemeIdNumber);
  const themeName = chosenTheme?.name ?? "";

  const onClick = () => {
    void onPublishToTheme(chosenThemeIdNumber, themeName);
  };

  return (
    <VerticalStack gap="4">
      <UnsupportedThemeBanner />
      <HorizontalStack gap="4" blockAlign="center" wrap={false}>
        <div data-testid="install-portal-theme-label">
          <VerticalStack gap="1">
            <Text as="span" variant="bodyMd">
              Theme:{" "}
              <Text as="span" variant="bodyMd" fontWeight="bold">
                {themeName}
                {chosenTheme?.role === "main" ? " (Live theme)" : ""}
              </Text>
            </Text>
            <Text as="p" variant="bodySm" color="subdued">
              Selected in the Add Subscription App Block step.
            </Text>
          </VerticalStack>
        </div>
        <div data-testid="install-portal-button">
          <Button
            primary
            loading={isLoading}
            disabled={!isThemeValid || isAlreadyInstalledToChosenTheme}
            onClick={onClick}
          >
            Install portal
          </Button>
        </div>
      </HorizontalStack>
    </VerticalStack>
  );
};
